export class ListGcpNetworksResponseNetworksInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkName",
            "baseName": "networkName",
            "type": "string",
            "format": ""
        },
        {
            "name": "project",
            "baseName": "project",
            "type": "string",
            "format": ""
        },
        {
            "name": "isPeered",
            "baseName": "isPeered",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGcpNetworksResponseNetworksInner.attributeTypeMap;
    }
    constructor() {
    }
}
